import { createFileRoute } from "@tanstack/react-router";
import { assert } from "utils";

import { loaderHandler } from "src/lib/loaderHandler";
import { CoachLibraryProgramLayout } from "src/pages/CoachLibraryProgramLayout";
import { createPersonalLibraryProgramsRepository } from "src/repositories/programs/createPersonalLibraryProgramsRepository";
import { exerciseCategoriesQueryOptions } from "src/state/exerciseCategories";
import { exerciseMovementPatternsQueryOptions } from "src/state/exerciseMovementPatterns";
import { exerciseMuscleGroupsQueryOptions } from "src/state/exerciseMuscleGroups";

export const Route = createFileRoute(
  "/_auth/_coach/library/programs/$programId",
)({
  component: RoutePage,
  ssr: true,
  shouldReload: false,
  async loader({ context, params }) {
    return await loaderHandler(async () => {
      assert(params.programId, "No programId");

      const programsRepository = createPersonalLibraryProgramsRepository();
      const [program] = await Promise.all([
        context.queryClient.query({
          ...programsRepository.detailOptions(params.programId),
          staleTime: "static",
        }),
        context.queryClient.query({
          ...exerciseCategoriesQueryOptions(),
          staleTime: "static",
        }),
        context.queryClient.query({
          ...exerciseMuscleGroupsQueryOptions(),
          staleTime: "static",
        }),
        context.queryClient.query({
          ...exerciseMovementPatternsQueryOptions(),
          staleTime: "static",
        }),
      ]);

      return {
        data: {
          program,
        },
        breadcrumb: {
          id: program.id,
          label: program.name,
          href: `/library/programs/${program.id}`,
        },
      };
    });
  },
});

function RoutePage() {
  return <CoachLibraryProgramLayout />;
}
